/* eslint no-underscore-dangle: 0 */
import React from 'react';
import { connect } from 'react-redux';
import VisibilitySensor from 'react-visibility-sensor';
import { Card } from 'react-toolbox/lib/card';
import Input from 'react-toolbox/lib/input';

import Spinner from '~/components/Spinner';
import { list, refresh3dCart } from '~/actions/products';
import { Button } from 'react-toolbox/lib/button';

import style from './style.scss';

class Products extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired,
    router: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      result: [],
      loading: false,
      query: '',
      from: null,
      limit: 50,
    };
  }

  componentDidMount() {
    this.find();
  }

  find() {
    this.setState({ loading: true });
    list(
      this.props.dispatch,
      this.context.apiClient,
      { query: this.state.query, limit: this.state.limit, from: this.state.from }
    )
      .then(r => this.setState({ loading: false, result: [...this.state.result, ...r.data] }))
      .catch(() => this.setState({ loading: false }));
  }

  navigate(url) {
    this.context.router.history.push(url);
  }

  renderProduct(product) {
    return (
      <Card key={product.CatalogID3DCart} className={style.product} onClick={() => this.navigate(`/product/${product.CatalogID3DCart}`)}>
        <div
          className={style.image}
          style={{ backgroundImage: `url(https://www.partynuts.com/${product.raw.ThumbnailFile})` }}
        />
        <div className={style.name}>{product.raw.SKUInfo.Name}</div>
        <div className={style.price}>$ {product.raw.SKUInfo.Price}</div>
        <div className={style.stock}>
          {Object.keys(this.props.locations).map(l => <div key={l} className={style.location}>
            {this.props.locations[l].name}: {product.stock[l] || 0}
          </div>)}
        </div>
      </Card>
    );
  }

  render() {
    return (
      <div style={{ padding: '10px' }}>
        <div className={style.title}>Products</div>
        <div className={style.searchBox}>
          <Input
            className={style.search}
            type="text"
            label="Search"
            value={this.state.query}
            onChange={query => this.setState({ query })}
          />
          <Button
            className={style.button}
            primary
            raised
            label="Find"
            icon="search"
            onClick={() => this.setState({ from: null, result: [] }, () => this.find())}
          />
        </div>
        <Button
          onClick={() => refresh3dCart(this.context.apiClient)}
          primary
          label="Sync all products from 3D cart"
          icon="cached"
          className={style.refreshAll}
        />
        <div>
          {this.state.result.map(p => this.renderProduct(p))}
          {this.state.loading && <Spinner />}
          <VisibilitySensor
            onChange={visible => {
              if (visible && this.state.result.length && !this.state.loading) {
                this.setState(
                  { from: this.state.result[this.state.result.length - 1]._id },
                  () => this.find()
                );
              }
            }}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  locations: state.getIn(['locations', 'locations']).toJS(),
});

export default connect(mapStateToProps)(Products);



// WEBPACK FOOTER //
// ./app/pages/Products/index.js